exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AccountSettingsSideMenu-listContainer-8ttXQ {\n  list-style-type: none;\n}\n.AccountSettingsSideMenu-sideNavitem-k3xS2{\n  display: block;\n  padding: 8px 0;\n  font-size: 16px;\n  color: #767676;\n  -webkit-text-decoration: none !important;\n  text-decoration: none !important;\n}", ""]);

// exports
exports.locals = {
	"listContainer": "AccountSettingsSideMenu-listContainer-8ttXQ",
	"sideNavitem": "AccountSettingsSideMenu-sideNavitem-k3xS2"
};